<h2 mat-dialog-title>
  <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between" fxFlex="100">
    <span>Add item</span>
    <mat-icon (click)="reference?.close()">close</mat-icon>
  </div>
</h2>
<div mat-dialog-content>
  <div [@contentHeight]="contentState" class="animated-content" [ngClass]="{ 'captain-app': environment.isCaptain }">
    <div>
      <input type="text" class="search-input" placeholder="Search here" [formControl]="searchControl" />
    </div>
    @if (isLoading) {
      <div fxLayout="row" fxLayoutAlign="center center" style="padding: 30px 0">
        <mat-spinner [diameter]="40" />
      </div>
    }
    @if (result?.items.length === 0 && result?.small_items.length === 0 && !isLoading) {
      <div fxLayout="row" fxLayoutAlign="center center" style="padding: 28px 0">
        <i class="no-results">{{ searchControl.value ? '- NO RESULTS -' : '- TYPE IN YOUR ITEM NAME -' }}</i>
      </div>
    }
    @if (searchControl.value && result?.items) {
      <div class="search-results" fxLayout="column" fxLayoutGap="10px">
        @if (result?.small) {
          <div class="best-result" fxLayout="column" fxLayoutGap="15px" (click)="previewItem(result.small_items[0])">
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div fxLayout="row" fxLayoutGap="15px" fxFlex fxLayoutAlign="center center">
                <img
                  [src]="result.small_items[0].icon_url ? result.small_items[0].icon_url : 'assets/icons-v2/sm.svg'"
                  alt="result"
                  fxFlex
                />
                <div fxLayout="column" fxLayoutAlign="center" fxFlex>
                  <span>{{ result.small_items[0]?.name }}</span>
                  <span class="subtitle">
                    {{
                      result.small_items[0]?.description_preview
                        ? result.small_items[0]?.description_preview
                        : result.small_items[0]?.description
                    }}
                  </span>
                </div>
              </div>
              @if (data?.restrictedItems?.includes(result.small_items[0].id)) {
                <span class="restricted">Restricted</span>
              }
              <mat-icon svgIcon="ss3-arrow-right-blue" fxFlex />
            </div>
          </div>
        }
        @if (result?.small && result?.items.length > 0) {
          <div class="divider"></div>
        }

        @if (result?.items.length > 0) {
          <span class="section-title">Results for "{{ searchControl.value }}" ({{ result?.items.length }})</span>
          <div class="results" fxLayout="column">
            @for (i of result?.items; track i) {
              <div class="result-item" fxLayout="row" fxLayoutAlign="space-between center" (click)="previewItem(i)">
                <span>{{ i.name }}</span>
                @if (data?.restrictedItems?.includes(i.id)) {
                  <span class="restricted">Restricted</span>
                }
                <mat-icon svgIcon="ss3-arrow-right-blue" />
              </div>
            }
          </div>
        }
        <div class="divider"></div>
        <div class="custom-item" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px">
          <span>Still can't find your item?</span>
          <a fxLayout="row" fxLayoutAlign="center center" (click)="addCustomItem()">
            <span>Add Custom Item</span>
            <mat-icon svgIcon="plus-blue" />
          </a>
        </div>
      </div>
    }
  </div>
</div>
